import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import Search from './components/Search';
import { useNavigate } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import {
  countryCodes,
  occupationData,
  maritialStatus,
  familyStatus,
  familyValue,
  familyType,
  siblings_maritial_Status,
  hobbies_list,
  sports_list,
  education_list,
  department_list,
  cities_list,
  stateCodes,
  currencyCodes,
  get_searchResult
} from './redux/slice';

const index = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    country_codes,
    // Occupation_Data,
    maritial_Status,
    family_Status,
    family_Value,
    family_Type,
    // siblings_maritialStatus,
    // get_hobbies_list,
    // get_sports_list,
    education_details,
    department_details,
    city_details
  } = useSelector((state) => state.registrations);

  const { state_details } = useSelector((state) => state.edithoroscope);

  const { currency_data } = useSelector((state) => state.editpartner);
  const { search_details, searchResult_loading } = useSelector(
    (state) => state.searchresults
  );

  console.log('search_details', search_details);

  useEffect(() => {
    get_countryCodes();
    get_occupation();
    get_maritialStatus();
    get_familyStatus();
    get_familyValue();
    get_familyType();
    get_siblings_maritialStatus();
    get_hobbies();
    get_sports();
    get_education_details();
    get_department_details();
    get_cities();
    get_states();
    get_currency();
  }, []);

  const get_countryCodes = () => {
    dispatch(countryCodes());
  };
  const get_occupation = () => {
    dispatch(occupationData());
  };
  const get_maritialStatus = () => {
    const payload = { type: 'user' };
    dispatch(maritialStatus(payload));
  };
  const get_familyStatus = () => {
    dispatch(familyStatus());
  };
  const get_familyValue = () => {
    dispatch(familyValue());
  };
  const get_familyType = () => {
    dispatch(familyType());
  };
  const get_siblings_maritialStatus = () => {
    dispatch(siblings_maritial_Status());
  };
  const get_hobbies = () => {
    const payload = { type: 'hobby' };
    dispatch(hobbies_list(payload));
  };
  const get_sports = () => {
    const payload = { type: 'sport' };
    dispatch(sports_list(payload));
  };
  const get_education_details = () => {
    dispatch(education_list());
  };
  const get_department_details = () => {
    dispatch(department_list());
  };
  const get_cities = () => {
    dispatch(cities_list());
  };
  const get_states = () => {
    dispatch(stateCodes());
  };

  const get_currency = () => {
    dispatch(currencyCodes());
  };

  const onSubmit = async (values) => {
    // console.log('submit_values', values);
    let payload = {
      max_age: values.maxAge,
      min_age: values.minAge,
      max_height_cm: values.maxHeight,
      min_height_cm: values.minHeight,
      // marital_status: [values.marital_status_id],
      marital_status: values.marital_status_id
        ? [values.marital_status_id]
        : [],
      city: values.personal_city,
      state: values.personal_state,
      country: values.personal_country,
      // parent Educations
      parent_mother_education: values.desired_partner_mother_education,
      parent_father_education: values.desired_partner_father_education,
      family_type: values.family_type_id ? [values.family_type_id] : [],
      family_status: values.family_status_id ? [values.family_status_id] : [],
      // family_status: [values.family_status_id],
      // family_values_id: [values.family_values_id],
      family_values: values.family_values_id ? [values.family_values_id] : [],
      // Educations
      higher_education: values.highestEducation,
      employed_in: values.employmentType ? [values.employmentType] : [],
      department: values.department,
      // annual_income: values.annual_income
      max_income: values.max_income,
      min_income: values.min_income
      // work_location_country: values.country1,
      // work_location_state: values?.state1,
      // work_location_city: values?.city1
    };
    localStorage.setItem('search_result', JSON.stringify(payload));
    console.log('Send_Payload', payload);
    try {
      const response = await dispatch(get_searchResult(payload));
      if (response?.payload?.success) {
        // Navigate to /searchresult with payload data
        navigate('/searchresult', { state: { data: response.payload.data } });
      } else {
        console.error('API call failed:', response.payload.message);
      }
    } catch (error) {
      console.error('Error fetching search result:', error);
    }
  };

  return (
    <>
      <Layout sider={true}>
        <Search
          maritial_Status={maritial_Status}
          state_details={state_details}
          family_Status={family_Status}
          family_Value={family_Value}
          family_Type={family_Type}
          city_details={city_details}
          country_codes={country_codes}
          currency_data={currency_data}
          education_list={education_details}
          department_details={department_details}
          onSubmit={onSubmit}
          searchResult_loading={searchResult_loading}
        />
      </Layout>
    </>
  );
};

export default index;
